import { httpClient } from 'app/api/http/http-client';
import { useMutation, useQuery } from 'react-query';

const refreshToken = localStorage.getItem('refreshToken');

const clientService = {
  getEmployeeList: async () => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/get_employees_list');

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'profile?type=information';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  getUserProfile: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/get_user_profile', { employee_id: data });

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'profile?type=information';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  employeeSetStatus: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/employee_set_status', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'profile?type=information';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  employeeUpsert: async (data: any) => {
    try {
      const result = await httpClient.post<any>(
        `/api-web/v1/main/employee_upsert?business_key=${data.businessKey}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'profile?type=information';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  getProfile: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/profile', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'profile?type=information';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useGetEmployeeList = () => {
  const {
    isLoading: isLoadingGetEmployeeList,
    data: dataGetEmployeeList,
    // mutate: getEmployeeListMutation,
    refetch: refetchEmployeeList,
  } = useQuery(['getEmployeeList'], clientService.getEmployeeList, {
    cacheTime: 0,
    enabled: false,
  });

  return { isLoadingGetEmployeeList, dataGetEmployeeList, refetchEmployeeList };
};

export const useGetUserProfile = () => {
  const {
    isLoading: isLoadingGetUserProfile,
    data: dataGetUserProfile,
    mutate: getUserProfileMutation,
  } = useMutation(['getUserProfile'], (data: any) => clientService.getUserProfile(data));

  return { isLoadingGetUserProfile, dataGetUserProfile, getUserProfileMutation };
};

export const useEmployeeSetStatus = () => {
  const { refetchEmployeeList } = useGetEmployeeList();
  const {
    isLoading: isLoadingEmployeeSetStatus,
    data: dataEmployeeSetStatus,
    mutate: employeeSetStatusMutation,
  } = useMutation(['employeeSetStatus'], (data: any) => clientService.employeeSetStatus(data), {
    onSuccess: () => {
      refetchEmployeeList();
    },
  });

  return { isLoadingEmployeeSetStatus, dataEmployeeSetStatus, employeeSetStatusMutation };
};

export const useEmployeeUpsert = () => {
  const {
    isLoading: isLoadingEmployeeUpsert,
    data: dataEmployeeUpsert,
    mutate: employeeUpsertMutation,
  } = useMutation(['employeeUpsert'], (data: any) => clientService.employeeUpsert(data));

  return { isLoadingEmployeeUpsert, dataEmployeeUpsert, employeeUpsertMutation };
};

export const useGetProfile = () => {
  const {
    isLoading: isLoadingGetProfile,
    data: dataGetProfile,
    mutate: getProfileMutation,
  } = useMutation(['getProfile'], (data: any) => clientService.getProfile(data));

  return { isLoadingGetProfile, dataGetProfile, getProfileMutation };
};
